import { SurveyUserTypes } from '../constants-types/Enums';
import { Folder } from '../core-data-model/Folder.model';
import { JobStub } from '../core-data-model/Job/JobStub.model';
import { Language } from '../shared/Language.model';
import { StakeholderNotificationInfo } from './OpenInvitationApi.serverinterface';
import { UserStub } from './User.model';

abstract class BaseOiLink {
    linkName: string;
    longUrl: string;
    shortenedUrl: string;
    kioskMode: boolean;
    sendAnalystCompletionEmail: boolean;

    jobId: string;
    folderId: string;
    personType: SurveyUserTypes;
    sendCogAfterBA: boolean;
    autoSendReport: boolean;
    createdDateTime: Date;
    stakeHoldersEmailList: string;
}

export class OiLink extends BaseOiLink {
    constructor(obj: any) {
        super();
        Object.assign(this, obj);
    }
}

export class Oi1Link extends BaseOiLink {
    isOi1: boolean;

    constructor(obj: any) {
        super();
        Object.assign(this, obj);
        this.isOi1 = true;
    }
}

export function isOiLink1(oiLink: OiLink | Oi1Link): oiLink is Oi1Link {
    return (<Oi1Link>oiLink).isOi1 !== undefined;
}

export class OpenInvitation {
    readonly id: string;
    readonly linkUrl: string;
    readonly linkName: string;
    readonly description: string;
    readonly personType: SurveyUserTypes;
    readonly folder: Folder;
    readonly job: JobStub;
    readonly ownerFirstName: string;
    readonly ownerLastName: string;
    readonly ownerEmail: string;
    readonly kioskMode: boolean;
    readonly autosendCognitive: boolean;
    readonly redirectUrl: string;
    readonly notifyAssessmentTaker: boolean;
    readonly includeBAReportInAssessmentTakerEmail: boolean;
    readonly notifyAssessmentSender: boolean;
    readonly includeBAReportInLinkSenderEmail: boolean;
    readonly notifyStakeholders: boolean;
    readonly includeBAReportInStakeholderEmail: boolean;
    readonly stakeholderEmails: string;
    readonly language: Language;
    readonly createdBy: UserStub;
    readonly createdDate: Date;
    readonly modifiedBy: UserStub;
    readonly modifiedDate: Date;

    constructor(startingValues?: Partial<OpenInvitation>) {
        Object.assign(this, startingValues);
    }
}

export class OpenInvitationUpdate {
    originalObject: OpenInvitation | null;

    linkName: string;
    description: string;
    personType: SurveyUserTypes;
    folder: Folder;
    job: JobStub;
    ownerFirstName: string;
    ownerLastName: string;
    ownerEmail: string;
    kioskMode: boolean;
    autosendCognitive: boolean;
    redirectUrl: string;
    notifyAssessmentTaker: boolean;
    includeBAReportInAssessmentTakerEmail: boolean;
    notifyAssessmentSender: boolean;
    includeBAReportInLinkSenderEmail: boolean;
    notifyStakeholders: boolean;
    includeBAReportInStakeholderEmail: boolean;
    stakeholderEmails: string;
    stakeholderNotifications?: StakeholderNotificationInfo[];
    language: Language;

    constructor(startingValues?: Partial<OpenInvitationUpdate>) {
        Object.assign(this, startingValues);
    }
}
